import { createReducer } from 'typesafe-actions';
import { searchKeywordAction, searchKeywordState } from './types';

import { SET_SEARCH_KEYWORD } from './actions';

const initialState: searchKeywordState = {
  searchKeyword: '',
};

const reducer = createReducer<searchKeywordState, searchKeywordAction>(
  initialState,
  {
    [SET_SEARCH_KEYWORD]: (state, action) => ({
      ...state,
      searchKeyword: action.payload,
    }),
  }
);

export default reducer;
